module.exports = __webpack_public_path__ + "static/coins-0fccb2b2023a55ce29c6107edccaa9fe.svg";